module.exports = __webpack_public_path__ + "static/media/AssessorTech.2c9e5399.svg";